<template>
  <v-app>
      <div v-if="isLoginPage">
        <AppBar/>
      </div>
     
    <v-main>

    
          <div v-if="isAppLoading" class="loading-overlay">
        <div class="loading-spinner">
          <v-progress-circular indeterminate color="white" />
          <span>Chargement...</span>
        </div>
      </div>        

      <router-view></router-view>
    </v-main>
    <Footer></Footer>
  </v-app>
</template>




<script>


import AppBar from '@/components/AppBar';
import Footer from '@/components/Footer';

import { getLoadingState } from "@/services/RequestService"; // Remplacez par le bon chemin de fichier

export default {
  name: 'App',

  components:{AppBar, Footer,},
 
  data: () => ({
                show: true,
                label: 'Loading...',
                timeOut: 2000,
                overlay: false,
                isAppLoading: false, // État local pour détecter le chargement
    }),
  mounted() {
    this.loadingInterval = setInterval(() => {
      this.isAppLoading = getLoadingState();
    }, 100);
  },
  beforeUnmount() {
    clearInterval(this.loadingInterval); // Nettoyage de l'intervalle
  },
  computed:{
    isLoginPage(){
      //console.log(this.$route.path)
      return this.$route.path !== "/Login" && this.$route.path !== "/login"
    },
  },
};
</script>
<style>
/* Overlay plein écran */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7); /* Fond gris avec opacité */
  z-index: 9999; /* Par-dessus tout */
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Contenu du spinner */
.loading-spinner {
  text-align: center;
  color: white;
  font-size: 1.5rem;
}

.loading-spinner span {
  display: block;
  margin-top: 1rem;
}
</style>